// Orchard: beverages are no longer pre-order. Remove every pre-order surface on
// the custom PDP — the buy-button label, the post-add toast wording (via the
// preorder flag), and any standalone "pre-order" badge/pill. Additive and safe;
// remove the <script src='oe-preorder-fix.js'> include in layout/orchard.liquid to revert.
(function () {
  function killFlag() {
    try { var P = window.PROD || {}; for (var k in P) { if (P[k]) P[k].preorder = false; } } catch (e) {}
  }
  function fix() {
    var t = document.querySelector('#buybtn .t');
    if (t && /pre-?order/i.test(t.textContent)) {
      t.textContent = t.textContent.replace(/pre-?order/i, 'add to cart');
    }
    var pills = document.querySelectorAll('#pdp .badges span, #pdp .ptag, #pdp .crumb');
    for (var i = 0; i < pills.length; i++) {
      if (/^\s*pre-?order\s*$/i.test(pills[i].textContent)) pills[i].style.display = 'none';
    }
  }
  function attach() {
    var b = document.getElementById('pdp');
    if (!b) return false;
    try { new MutationObserver(fix).observe(b, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    fix();
    return true;
  }
  function boot() {
    killFlag();
    if (attach()) return;
    var n = 0, iv = setInterval(function () { killFlag(); if (attach() || ++n > 50) clearInterval(iv); }, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
